import _objectSpread from "C:\\Users\\haouari-n\\Desktop\\CrateV2\\reactcrate\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/objectSpread";
import _classCallCheck from "C:\\Users\\haouari-n\\Desktop\\CrateV2\\reactcrate\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/classCallCheck";
import _createClass from "C:\\Users\\haouari-n\\Desktop\\CrateV2\\reactcrate\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "C:\\Users\\haouari-n\\Desktop\\CrateV2\\reactcrate\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "C:\\Users\\haouari-n\\Desktop\\CrateV2\\reactcrate\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/getPrototypeOf";
import _inherits from "C:\\Users\\haouari-n\\Desktop\\CrateV2\\reactcrate\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/inherits";
import Marker from './marker';
import { EventEmitter } from 'events';

var debug = require('debug')('CRATE:View:MarkerViewManager');
/**
 * This class manages markers,pings,cursors of the different users
 */


export var MarkerViewManager =
/*#__PURE__*/
function (_EventEmitter) {
  _inherits(MarkerViewManager, _EventEmitter);

  function MarkerViewManager(MarkerManager, editor) {
    var _this;

    _classCallCheck(this, MarkerViewManager);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(MarkerViewManager).call(this));
    /**
     * markers contains all marks of the users: carets, avatars...
     * @type {Marker[]}
     */

    _this._markerManager = MarkerManager;
    _this._editor = editor;
    _this._markers = {};

    _this.addMarker(_this._markerManager._document.uid, true);

    _this._markerManager.on('Ping_received', function (msg) {
      _this.receivePing(msg);
    });

    _this._markerManager.on('Caret_received', function (msg) {
      _this.receiveCaret(msg);
    });

    _this._defaultOptions = {
      lifeTime: 5000
    };
    return _this;
  }

  _createClass(MarkerViewManager, [{
    key: "addMarker",
    value: function addMarker(id) {
      var isItMe = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      var opts = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
      var options = Object.assign(_objectSpread({}, this._defaultOptions, {
        isItMe: isItMe
      }), opts);

      if (!this._markers.hasOwnProperty(id)) {
        this._markers[id] = new Marker(id, options, this._editor);

        if (isItMe) {
          if (store.get('myId')) {
            this._markers[id].setPseudo(store.get('myId').pseudo);
          } else {
            store.set('myId', {
              id: id,
              pseudo: this._markers[id].pseudoName
            });
          }
        }
      }

      return this._markers[id];
    }
  }, {
    key: "getMarker",
    value: function getMarker(id) {
      return this._markers[id];
    }
  }, {
    key: "receivePing",
    value: function receivePing(_ref) {
      var id = _ref.id,
          pseudo = _ref.pseudo;
      debug('Ping Received', id, pseudo);

      if (this.getMarker(id)) {
        this.getMarker(id).update(null, false) // to keep avatar
        .setPseudo(pseudo);
      } else {
        // to create the avatar
        this.addMarker(id, false).setPseudo(pseudo);
      }
    }
    /**
     *  At the reception of CARET position
     * @param  {[type]} range  [description]
     * @param  {[type]} id [description]
     * @return {[type]}        [description]
     */

  }, {
    key: "receiveCaret",
    value: function receiveCaret(_ref2) {
      var range = _ref2.range,
          id = _ref2.id;
      if (!id) return;

      if (this.getMarker(id)) {
        this.getMarker(id).update(range, true); // to keep avatar
      } else {
        this.addMarker(id, false, {
          range: range
        });
      }
    }
  }, {
    key: "removeMarker",
    value: function removeMarker() {}
  }]);

  return MarkerViewManager;
}(EventEmitter);